import request from '@/utils/http';
// 个人列表
export const getPersonage = (params) => {
    return request({
        url: '/api-auth/userInfos',
        method: 'GET',
        params: params,
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
        }
    });
};
